import { makeStyles, tokens } from '@fluentui/react-components';

export const useConfigurationTableStyles = makeStyles({
    root: {
        height: 'calc(100% - 50px)',
        minHeight: 0,
        boxSizing: 'border-box',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    tableScrollContainer: {
        paddingTop: tokens.spacingVerticalM,
        paddingLeft: tokens.spacingHorizontalL,
        paddingRight: tokens.spacingHorizontalL,
        paddingBottom: tokens.spacingVerticalM,
        minHeight: 0,
        overflow: 'auto',
        flex: '1 1 auto',
        boxSizing: 'border-box',
    },
    dataGrid: {
        height: 'fit-content',
        width: '100%',
        boxSizing: 'border-box',
    },
    spinner: {
        position: 'absolute',
        minWidth: '100%',
        top: '50%',
    },
    paginationSection: {
        flexShrink: 0,
    },
});
